import React from 'react';
export function ProductPreview() {
  return <section className="py-8 md:py-16 bg-brand-bg" data-id="element-243">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-244">
        <div className="mb-6 md:mb-10" data-id="element-245">
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1.5" data-id="element-246">
            VISTA PREVIA
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-247">
            Explorá el interior del Megapack
          </h3>
          <p className="text-gray-600 text-xs md:text-base max-w-2xl mx-auto leading-snug" data-id="element-248">
            Conocé la calidad de nuestros protocolos, plantillas y checklists
            antes de tu próxima guardia.
          </p>
        </div>

        <div className="relative mx-auto max-w-[280px] md:max-w-md rounded-[2rem] md:rounded-[2.5rem] border-[6px] md:border-[8px] border-gray-900 bg-gray-900 shadow-2xl overflow-hidden" data-id="element-249">
          {/* Subtle glare effect for device mockup feel */}
          <div className="absolute top-0 inset-x-0 h-20 bg-gradient-to-b from-white/10 to-transparent z-10 pointer-events-none" data-id="element-250"></div>

          <video src="https://cdn.magicpatterns.com/uploads/d8Q2wT5LM9Z4Cca1yRnimQ/screenrecord psiquaitria.mov" className="w-full h-auto block" autoPlay muted loop playsInline controls={false} data-id="element-251" />
        </div>
      </div>
    </section>;
}